import _ from 'lodash';
import i18n from '@/i18n';
import rankTypesJson from '@/json/rankTypes.json';
import RANK_LABEL_MAPPING from '@/constant/rankLabelMapping';

const {RANK_TYPE, RANK_TYPE_LABEL} = rankTypesJson;

/**
 * @param {Number} gameRank - presentation of rank of game.
 * @param {String} rankType - rankType
 * @return {String} - e.g. '2k'.
 */
const convertRank = _.memoize(
  (gameRank, rankType = RANK_TYPE.IGQE) => {
    // Map from game ranking difinition to Go ranking definition.
    const findResult = RANK_LABEL_MAPPING.findLast(
      (doc) => parseInt(gameRank) >= doc.value && doc[rankType]
    );
    if (!findResult) return gameRank;
    return findResult[rankType];
  },
  (gameRank, rankType = RANK_TYPE.IGQE) => {
    return JSON.stringify({gameRank, rankType});
  }
);

/**
 * @param {Object} config {rankLowerBond, rankUpperBond} - presentation of rank of game.
 * @param {String} rankType - rankType
 * @return {String} - e.g. '2k' || '18k~2k'.
 */
const convertRankBond = (
  {rankLowerBond, rankUpperBond},
  rankType = RANK_TYPE.IGQE
) => {
  /**
   * @param {Number} rank rank
   * @return {String} G1
   */
  const _convertRank = (rank) => {
    if (rank === -1) {
      return i18n.t('不限');
    }
    return convertRank(rank, rankType);
  };
  if (rankLowerBond !== rankUpperBond) {
    return `${_convertRank(rankLowerBond)}~${_convertRank(rankUpperBond)}`;
  } else {
    return _convertRank(rankLowerBond);
  }
};

/**
 * @param {String} rankType IGQE
 * @return {String} igqeRank...
 */
const getRankTypeKey = (rankType) => {
  return `${rankType.toLowerCase()}Rank`;
};

/**
 * @param {String} rankTypeKey igqeRank
 * @return {String} IGQE
 */
const rankTypeKey2RankType = (rankTypeKey) => {
  return rankTypeKey.replace('Rank', '').toUpperCase();
};

/**
 * @param {String} rankType igqeRank
 * @return {Boolean} isIgqe
 */
const isIgqe = (rankType) => {
  return rankType === RANK_TYPE.IGQE;
};

/**
 * @param {String} rankType IGQE
 * @return {String} IGQE
 */
const getRankTypeLabel = (rankType) => {
  return RANK_TYPE_LABEL[rankType];
};

const getRankList = _.memoize((rankType = RANK_TYPE.IGQE) => {
  return RANK_LABEL_MAPPING.filter((item) => item[rankType]).map((item) => ({
    label: item[rankType],
    text: item[rankType],
    value: item.value,
  }));
});

/**
 * @param {String} rankType IGQE
 * @return {String} IGQE
 */
const isUnofficialRankType = (rankType) => {
  return [RANK_TYPE.IGQE, RANK_TYPE.TW].includes(rankType);
};

export {
  convertRank,
  getRankList,
  convertRankBond,
  getRankTypeKey,
  rankTypeKey2RankType,
  isIgqe,
  getRankTypeLabel,
  isUnofficialRankType,
};
